// Today's challenges on their own screen, reached from the menu.

import { S } from '../strings';
import { Challenges } from '../ui/Challenges';
import { ScreenTop } from '../ui/ScreenTop';

export function Today() {
  return (
    <main className="screen today-screen">
      <ScreenTop title={S.menu.today} />
      <Challenges />
    </main>
  );
}
